'use client';

import { useBodyScrollLock } from '@lib/hooks/use-body-scroll-lock';

export default function BodyScrollLock({ enabled }: { enabled: boolean }) {
  useBodyScrollLock(enabled);
  return null;
}
